import { useEffect, useRef } from 'react';

export default function useMounted(initialValue = true) {
  const isMountedRef = useRef(initialValue);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
